import Breadcrumb from "@/components/common/Breadcrumb";
import { MaskLine } from "@/components/common/Reveal";

/** Inner-page hero with breadcrumb, title and optional intro. */
export default function PageHero({ breadcrumb, title, intro, eyebrow }) {
  return (
    <section className="relative overflow-hidden bg-brand-blue pt-32 pb-16 lg:pt-40 lg:pb-20" data-testid="page-hero">
      <div className="absolute inset-0 opacity-[0.07] bg-grid" />
      <div className="absolute -right-24 -top-24 h-96 w-96 rounded-full bg-brand-red/20 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        {breadcrumb && (
          <div className="[&_*]:!text-white/60 [&_.font-medium]:!text-white">
            <Breadcrumb items={breadcrumb} />
          </div>
        )}
        {eyebrow && (
          <span className="mt-6 inline-block text-xs font-semibold uppercase tracking-[0.2em] text-brand-red-light">
            {eyebrow}
          </span>
        )}
        <h1 className="mt-3 max-w-4xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
          <MaskLine>{title}</MaskLine>
        </h1>
        {intro && <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg">{intro}</p>}
      </div>
    </section>
  );
}
